import { memo } from 'react';
import { Merge } from 'lucide-react';
import type { NodeProps } from '@xyflow/react';
import type { ComposerNodeData } from '../../../types/composer';
import { ComposerNodeCard } from './ComposerNodeCard';

export const MergeNode = memo((props: NodeProps) => (
  <ComposerNodeCard
    {...props}
    data={props.data as ComposerNodeData}
    typeName="merge"
    glyph={<Merge size={14} strokeWidth={2.2} />}
  />
));

MergeNode.displayName = 'MergeNode';
